import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { Service } from '../services';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { GlobalService } from '../global.service';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material';
import { Subscription } from "rxjs";
import { AngularFireAnalytics } from '@angular/fire/analytics';
@Component({
  selector: 'app-paperless',
  templateUrl: './paperless.component.html',
  styleUrls: ['./paperless.component.sass']
})
export class PaperlessComponent implements OnInit {
  public banlist;
  public tabActive = 'Factura y Pago';
  public selectBan;
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public token: string = sessionStorage.getItem("token");
  loadObserver: Subscription;
  public paperless;

  constructor(private router: Router, public appComponent: AppComponent, private services: Service, private loadingScreenService: LoadingScreenService, public global: GlobalService, public dialog: MatDialog, public AngularFireAnalytics: AngularFireAnalytics) {
    this.AngularFireAnalytics.setCurrentScreen("Factura Electrónica");
    this.AngularFireAnalytics.logEvent("Factura Electrónica-Screenview");
  }

  ngOnInit() {
    this.global.validateSession();
    this.paperless = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).qualification.RefererResponse.paperless;
    this.banlist = JSON.parse(atob(sessionStorage.getItem("getAcoout"))).accounts.AccountList;
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    this.loadingScreenService.stopLoading();
    this.loadObserver = this.global.loadObserver.subscribe((value: number) => {
      this.dataLoading(value)
    });
  }
  dataLoading(sw) {
    this.paperless = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).qualification.RefererResponse.paperless;
  }
  refreshDataTo(event: Event) {
    if (this.global.validateSession() === true) {
      let index = parseInt(event.target["selectedIndex"]);
      let ban = this.banlist[index].account;
      sessionStorage.setItem("selectBan", btoa(ban));
    }
  }
  changeBan() {
    this.global.validateSession();
    sessionStorage.setItem("selectBan", btoa(this.selectBan));
    var index = this.banlist.map(function (e) { return e.account; }).indexOf(this.selectBan);
    this.loadingScreenService.startLoading();
    this.services.accountDetails(sessionStorage.getItem("token"), btoa(this.banlist[index].subsriberByDefault), btoa(this.banlist[index].account)).subscribe(data2 => {
      if (data2.HasError == false) {
        this.loadingScreenService.stopLoading();
        sessionStorage.setItem("getAccountDetails", btoa(JSON.stringify(data2)));
      }
      else {
        this.global.notif(data2.ErrorDesc);
        this.loadingScreenService.stopLoading();
      }
    });
  }
}